import FingerprintComponent from "./fingerprintComponent";
import LocalForagePersisterComponent from "./localForagePersisterComponent";
import ReactQueryComponent from "./reactQueryComponent";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import ScrollComponent from "./scrollComponent";

const Test = () => {
  return (
    <>
      <ScrollComponent />
      <div className=" bg-slate-100 m-2 p-2">
        <FingerprintComponent />
      </div>
      <div className=" bg-slate-100 m-2 p-2">
        <QueryErrorResetBoundary>
          {({ reset }) => (
            <div onReset={reset}>
              <ReactQueryComponent />
            </div>
          )}
        </QueryErrorResetBoundary>
      </div>
      <LocalForagePersisterComponent />
    </>
  );
};

export default Test;
